import { render, staticRenderFns } from "./tiscTab.vue?vue&type=template&id=3479f9b8&scoped=true&"
import script from "./tiscTab.vue?vue&type=script&lang=js&"
export * from "./tiscTab.vue?vue&type=script&lang=js&"
import style0 from "./tiscTab.vue?vue&type=style&index=0&id=3479f9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479f9b8",
  null
  
)

export default component.exports